function TabletIcon({
  size = 20,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5 2.50016C4.53976 2.50016 4.16667 2.87326 4.16667 3.3335V16.6668C4.16667 17.1271 4.53976 17.5002 5 17.5002H15C15.4602 17.5002 15.8333 17.1271 15.8333 16.6668V3.3335C15.8333 2.87326 15.4602 2.50016 15 2.50016H5ZM2.5 3.3335C2.5 1.95278 3.61929 0.833496 5 0.833496H15C16.3807 0.833496 17.5 1.95278 17.5 3.3335V16.6668C17.5 18.0475 16.3807 19.1668 15 19.1668H5C3.61929 19.1668 2.5 18.0475 2.5 16.6668V3.3335Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.16663 14.9998C9.16663 14.5396 9.53972 14.1665 9.99996 14.1665H10.0083C10.4685 14.1665 10.8416 14.5396 10.8416 14.9998C10.8416 15.4601 10.4685 15.8332 10.0083 15.8332H9.99996C9.53972 15.8332 9.16663 15.4601 9.16663 14.9998Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default TabletIcon;
